import Marquee from "react-fast-marquee";
import { Sparkle } from "lucide-react";

const ITEMS = ["Deep clean", "Restore", "Protect", "Collect", "Deliver", "Revive"];

export default function EditorialMarquee() {
  return (
    <section data-testid="marquee-section" className="border-y border-white/10 bg-obsidian py-10">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="mx-8 flex items-center gap-16">
            <span className="font-display text-3xl font-bold uppercase tracking-tight text-white/25 transition-colors duration-500 hover:text-aqua sm:text-4xl">
              {item}
            </span>
            <Sparkle size={18} className="text-aqua/60" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
